// Mal Kabul Yönetimi (WMS) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.receivingManagement';

export const wmsReceivingManagementGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Mal Kabul Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'El terminalinde yapılan mal kabullerini (teslimatları) buradan izler, devam edenlere görevli atarsınız. Okutma, rafa yerleştirme ve tamamlama el terminalindeki Mal Kabul ekranında yapılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve Depo'),
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Durum ve arama'),
    toolbar: t(`${G}.regions.toolbar`, 'Yenile'),
    table: t(`${G}.regions.table`, 'Teslimat listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Depoyu seçin'),
      text: t(`${G}.s1.text`, 'Sağ üstteki "Depo" listesinden akıllı depoyu seçin. Kartlar ve liste seçilen deponun teslimatlarını gösterir; ilk depo otomatik seçilir.'),
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Özet kartlarını okuyun'),
      text: t(`${G}.s2.text`, 'Toplam Oturum: seçili durum filtresine uyan tüm teslimatlar. Bugün Oturum: bugün başlayan teslimatlar. Bugün Kalem: bugün başlayan teslimatlarda kabul edilen toplam ürün adedi. Devam Eden: henüz tamamlanmamış teslimatlar.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Teslimatı bulun'),
      text: t(`${G}.s3.text`, '"Durum" ile Devam Eden veya Tamamlanan teslimatları süzün. Arama kutusu teslimat no, tedarikçi, irsaliye no ve görevli adında arar. Yenile düğmesi listeyi ve kartları günceller.'),
      tips: [
        t(`${G}.s3.tip1`, 'Arama yalnız o an açık olan sayfadaki satırlarda yapılır; aradığınızı bulamazsanız sayfayı değiştirin ya da durum filtresini kullanın.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Durumu ve ayrıntıyı inceleyin'),
      text: t(`${G}.s4.text`, 'Her satırda Teslimat No, Görevli, Ürün (toplam adet), Çeşit, Durum (Devam Ediyor / Tamamlandı), Başlangıç ve Bitiş görünür. Göz simgesi "Teslimat Detayı"nı açar: tedarikçi, irsaliye, notlar ve kabul edilen her ürünün miktarı, lokasyonu, durumu (Kabul / Yerleştirildi) ve yerleştirme zamanı.'),
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Görevli atayın'),
      text: t(`${G}.s5.text`, 'Devam eden teslimatın satırındaki kişi simgesi ("Görevli Ata") teslimatı başka bir personele verir. Listede bu depodaki Mal Kabul ekranına yetkili personel çıkar; hiç ekran tanımlı değilse önce "Mal Kabul Ayarları"ndan ekran ekleyip personel atayın.'),
      tips: [
        t(`${G}.s5.tip1`, 'Tamamlanmış teslimata görevli atanamaz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Tamamlama ve stok etkisi'),
      text: t(`${G}.s6.text`, 'Akıllı depoda stok, ürün el terminalinde rafa yerleştirildiği anda o rafa eklenir; yalnız okutulan (Kabul durumundaki) ürün stoğu artırmaz. Teslimat, bütün ürünler yerleştirilmeden tamamlanamaz. El terminalinde iptal edilen teslimatta yerleştirilmiş ürünler stoktan geri alınır.'),
    },
  ],
});
